import { IYearMonth } from '@/coreDomainsModule/date';
import { IBusinessForCustomerForecast } from '@/coreDomainsModule/entities/businessForCustomerForecast';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import {
  BulkPostSupplierForecastByCustomerForecastRequestInfo,
  CustomerForecastFilterItem,
  PostSupplierForecastRequestInfo,
} from '@/coreInfrastructureModule/axios/generated/supplierForecastManage';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';

/**
 * UI用の型をAPIリクエストの型に変換する
 */
export class BulkPostSupplierForecastAdapter {
  /**
   * 客先内示情報を仕入先内示の登録用に変換する
   * @param createdYearMonth - 仕入先内示作成月
   * @param startForecastTargetYearMonth - 内示対象月の開始月
   * @param forecastTargetYearMonthCount - 内示対象月の数
   * @param filterItem - フィルター項目
   */
  public static adapt = (
    createdYearMonth: IYearMonth,
    startForecastTargetYearMonth: IYearMonth,
    forecastTargetYearMonthCount: number,
    filterItem?: FilterContentItem[]
  ): BulkPostSupplierForecastByCustomerForecastRequestInfo => {
    const targetYearMonthList: IYearMonth[] = [];
    for (let i = 0; i < forecastTargetYearMonthCount; i++) {
      const { updateYear: _year, updateMonth: _month } = DateService.updateYearMonth(
        startForecastTargetYearMonth.year,
        startForecastTargetYearMonth.month,
        i
      );
      targetYearMonthList.push({ year: _year, month: _month });
    }

    return {
      'receive-year': createdYearMonth.year,
      'receive-month': createdYearMonth.month,
      targetYearMonthList: targetYearMonthList,
      customerForecastFilterItem: this.generateFilterItem(filterItem),
    };
  };

  /**
   * フィルター項目をAPIリクエストの型に変換する
   * @param filterItem - フィルター項目
   */
  public static generateFilterItem = (filterItem?: FilterContentItem[]): CustomerForecastFilterItem | undefined => {
    const result: CustomerForecastFilterItem = {};

    if (!filterItem || filterItem.length <= 0) return undefined;

    filterItem.forEach((item) => {
      const key = FilterService.getKeyByFilterType(item.filterType);
      const resKey = item.selectedValue.map((selected) => encodeURIComponent(selected));
      result[key] = resKey.join(',');
    });

    return result;
  };
}
